import React, { FC } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { PendingCancellationDetailProps } from "./types";
import { RECURLY } from "../../../../../../constants/spCode";
import i18next from "../../../../../../i18n";
import { ACTION, SUBJECT } from "../../../../../../constants/permissions";
import PromoCodeField from "../../../../../../components/PromoCodeField";
import { capitalize } from "../../../../../../utils/common";
import { useIsShowPromotion } from "../../../../../../hooks/useIsShowPromotion";
import { PaymentMethodInfo } from "../../../PaymentMethodInfo/PaymentMethodInfo";
import { useAbility } from "../../../../../../hooks";
import { SUBSCRIPTION_STATUS } from "../../../../../../utils/common/contants";
import { selectCurrentSPS } from "../../../../../../store/metadata";

export const PendingCancellationDetail: FC<PendingCancellationDetailProps> = ({
  currentSubscription,
  isCorporate,
  onManageLicenses,
  paymentMethod,
  isAccountOverviewTab,
  paymentMethodIconName,
}) => {
  const { t } = useTranslation();
  const ability = useAbility();
  const { sp, totalLicenses, currentSKU } = currentSubscription;
  const serviceEndDate = sp.terminated_at ? new Date(sp.terminated_at) : null;
  const isShowServiceEndDate = sp.sp_code === RECURLY;
  const isShowPromotion = useIsShowPromotion(sp.promotion);
  const currentSPS = useSelector(selectCurrentSPS);
  const isShowPaymentMethod =
    !isAccountOverviewTab && (paymentMethod || currentSPS);

  return (
    <dl className="ams-active-subscription__details">
      <dt className="ams-active-subscription__details-label">{t("status")}</dt>
      <dd className="ams-active-subscription__details-value ams-active-subscription__status--warning">
        {t(`subscriptionStatus.${SUBSCRIPTION_STATUS.pendingCancellation}`)}
      </dd>

      {isCorporate && !isAccountOverviewTab && (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("numberOfLicenses")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            <span>{totalLicenses}</span>
            {ability.can(ACTION.WRITE, SUBJECT.BILLING) ? (
              <button
                className="ams-active-subscription__link-button ml-s"
                onClick={onManageLicenses}
              >
                {t("manageLicenses")}
              </button>
            ) : null}
          </dd>
        </>
      )}

      {isShowServiceEndDate && (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("serviceEndDate")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            {serviceEndDate &&
              t("date", {
                month: capitalize(
                  serviceEndDate.toLocaleString(i18next.language, {
                    month: "long",
                  }),
                ),
                day: serviceEndDate.getDate(),
                year: serviceEndDate.getFullYear(),
              })}
          </dd>
        </>
      )}

      {isShowPaymentMethod && (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("paymentMethod")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            <PaymentMethodInfo
              paymentMethod={paymentMethod}
              paymentMethodIconName={paymentMethodIconName}
            />
          </dd>
        </>
      )}

      {currentSKU?.sp.name ? (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("plan")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            {currentSKU?.sp.name}
          </dd>
        </>
      ) : null}

      {isShowPromotion && sp.promotion && !isAccountOverviewTab && (
        <>
          <dt className="ams-active-subscription__details-label">
            {t("promoCode")}
          </dt>
          <dd className="ams-active-subscription__details-value">
            <PromoCodeField promotion={sp.promotion} />
          </dd>
        </>
      )}
    </dl>
  );
};
